import React from 'react'
import { STATUS_SENT } from '@disco/constants/CampaignTypes'
import CampaignListPage from 'pages/campaigns/campaign-list'

const SentCampaignListPage = (): React.ReactNode => {
  return <CampaignListPage fullPage={STATUS_SENT} />
}

export default SentCampaignListPage
